import type { FC } from 'react';
import React from 'react';

import { Badge } from '../../Badge';
import { cnTag } from '../Tag.cn';

import './TagCounter.css';

interface TagCounterProps {
    text: string | number;
}

export const TagCounter: FC<TagCounterProps> = (props) => {
    const { text } = props;

    return <Badge content={text} className={cnTag('Counter')} />;
};
